import {
  ModalHeader as _ModalHeader,
  ModalBody as _ModalBody,
  ModalProps,
  Modal as _Modal,
  ModalFooter as _ModalFooter,
} from 'reactstrap'
import { JSXElementConstructor, useCallback, useState } from 'react'
import { createRoot, Root } from 'react-dom/client'
import Confirm from './ModalConfirm'
import ModalDefault from './ModalDefault'
import Alert from './ModalAlert'
import { getStore } from 'common/store'
import { Provider } from 'react-redux'

declare global {
  // eslint-disable-next-line no-var
  var closeModal: (() => void) | undefined
}

export const ModalHeader = _ModalHeader
export const ModalFooter = _ModalFooter
export const Modal = _Modal
export const ModalBody = _ModalBody
export const closeModal = () => global.closeModal?.()
const withModal = (WrappedComponent: JSXElementConstructor<any>) => {
  return (props: ModalProps) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [isOpen, setIsOpen] = useState(true)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const toggle = useCallback(() => setIsOpen(false), [setIsOpen])
    global.closeModal = toggle

    return (
      <Provider store={getStore()}>
        <WrappedComponent toggle={toggle} {...props} isOpen={isOpen} />
      </Provider>
    )
  }
}

const _Confirm = withModal(Confirm)
const _Alert = withModal(Alert)
const _ModalDefault = withModal(ModalDefault)

const roots: Record<string, Root> = {}

function getRoot(id: string): Root | null {
  const el = document.getElementById(id)
  if (!el) return null
  if (roots[id]) {
    roots[id].unmount()
  }
  roots[id] = createRoot(el)
  return roots[id]
}

export const openAlert = (global.openAlert = (title, children, onDismiss) => {
  const root = getRoot('alert')
  root?.render(
    <_Alert title={title} onDismiss={onDismiss}>
      {children}
    </_Alert>,
  )
})

export const openConfirm = (global.openConfirm = (
  title,
  body,
  onYes,
  onNo = undefined,
) => {
  const root = getRoot('confirm')
  root?.render(
    <_Confirm isOpen onNo={onNo} onYes={onYes} title={title}>
      {body}
    </_Confirm>,
  )
})

export const openModal = (global.openModal = (title, body) => {
  const root = getRoot('modal')
  root?.render(
    <_ModalDefault isOpen title={title}>
      {body}
    </_ModalDefault>,
  )
})

export default ModalDefault
